import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { enableInspectionService } from '../../api/inspection-service.ts';

export default function useEnableInspectionService(): UseMutationResult<
  Awaited<ReturnType<typeof enableInspectionService>>,
  Error,
  string
> {
  return useMutation({
    mutationFn: (serviceId: string) => enableInspectionService(serviceId),
  });
}
